import { CountryResponseWithNestedObjects } from '../../../../web-api-client';
import { Country } from '../../models';

export const mapCountryFromResponse = (
  response: CountryResponseWithNestedObjects
): Country => ({
  countryId: response.countryId!,
  region: response.region?.name ?? '',
  name: response.name!,
  code: response.code!,
});
